import request from '@/utils/request'


// 查询发现板块-用户社交列表
export function listDiscoverUserSocial(query) {
  return request({
    url: '/discovery/discover/user/social/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-用户社交分页
export function pageDiscoverUserSocial(query) {
  return request({
    url: '/discovery/discover/user/social/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-用户社交详细
export function getDiscoverUserSocial(data) {
  return request({
    url: '/discovery/discover/user/social/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-用户社交
export function addDiscoverUserSocial(data) {
  return request({
    url: '/discovery/discover/user/social/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-用户社交
export function updateDiscoverUserSocial(data) {
  return request({
    url: '/discovery/discover/user/social/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-用户社交
export function delDiscoverUserSocial(data) {
  return request({
    url: '/discovery/discover/user/social/delete',
    method: 'post',
    data: data
  })
}
